<template>
  <div class="box">
    <div class="left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="right">
      <div style="margin-top: 5px">
        <el-button size="mini" @click="search">查询</el-button>
<!--        <el-button size="mini" @click="addDialog">添加</el-button>-->
<!--        <el-button size="mini" @click="openDialog">导入目标</el-button>-->
        <el-button size="mini" @click="excelPost">导出</el-button>
      </div>
      <el-descriptions :column="2" size="mini" border style="margin-top: 8px">
        <el-descriptions-item label="房产">
          <el-input
            size="mini"
            v-model="form.houseName"
            placeholder="输入房产搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="目标年份">
          <el-date-picker
            size="mini"
            v-model="form.year"
            type="year"
            placeholder="选择年份"
            value-format="yyyy"
          >
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="筛选">
          <el-radio v-model="form.mode" label="1">项目</el-radio>
          <el-radio v-model="form.mode" label="2">区域</el-radio>
          <el-radio v-model="form.mode" label="3">战区</el-radio>
          <el-radio v-model="form.mode" label="4">地区</el-radio>
        </el-descriptions-item>
        <el-descriptions-item label="月份">
          <el-select v-model="form.month" placeholder="请选择" clearable size="mini">
            <el-option
              v-for="item in months"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
      <el-table
        style="margin-top: 8px"
        max-height="600"
        :data="listData"
        border
      >
        <el-table-column label="目标" prop="ancestor_name" />
        <el-table-column label="年份" prop="year" />
        <el-table-column label="月份" prop="month" />
        <el-table-column label="收缴类型">
          <template slot-scope="data"> {{ data.row.type }} </template>
        </el-table-column>
        <el-table-column label="目标收缴率">
          <template slot-scope="data"> {{ data.row.target }}% </template>
        </el-table-column>
        <el-table-column label="目标金额" prop="target_money" />
        <el-table-column label="应收总金额" prop="total_money" />
        <el-table-column label="操作">
          <template slot-scope="data">
            <el-button type="text" size="mini" @click="edit(data.row.id)">
              修改
            </el-button>
            <el-button type="text" size="mini" @click="del(data.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float: right; margin-top: 10px; margin-right: 20px"
        background
        :small="true"
        layout="prev, pager, next"
        :page-size="form.pageSize"
        :total="totalCount"
        :current-page.sync="form.page"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="添加/编辑目标"
      :visible.sync="modal"
      width="60%"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="addForm" label-width="120px" :rules="rules">
        <el-form-item label="目标类型">
          <el-select v-model="addForm.is_region" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标" prop="house_id">
          <el-select
            v-model="addForm.house_id"
            filterable
            remote
            :remote-method="remoteMethod"
            :loading="loading"
            placeholder="请选择目标"
            style="width: 100%"
          >
            <el-option
              v-for="item in targetList"
              :key="item.house_id"
              :label="item.houseName"
              :value="item.house_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生效年月" prop="date">
          <el-date-picker
            v-model="addForm.date"
            type="month"
            placeholder="选择年月"
            value-format="yyyy-MM"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="目标收缴率(%)" prop="target">
          <el-input v-model="addForm.target" placeholder="请输入目标收缴率" />
        </el-form-item>
        <el-form-item label="目标金额(万元)" prop="target_money">
          <el-input
            v-model="addForm.target_money"
            placeholder="请输入目标收缴金额（万元）"
          />
        </el-form-item>
        <el-form-item label="收缴类型" prop="type">
          <el-select v-model="addForm.type" placeholder="请选择">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="批量导入目标"
      :visible.sync="importVisible"
      width="60%"
      :before-close="handleCloseImport"
      v-loading="loading"
    >
      <el-upload
        class="upload-demo"
        :action="url"
        :before-remove="beforeRemove"
        :on-success="handleAvatarSuccess"
        accept=".xls,.xlsx"
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload"
      >
        <el-button size="small" type="primary" class="texts">
          点击上传
        </el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传xls或xlsx文件，且不超过7M
        </div>
      </el-upload>
      <el-button size="mini" @click="delNode"> 删除 </el-button>
      <el-button size="mini" @click="importExcelData"> 导入 </el-button>
      <el-button size="mini" @click="downloadExcel"> 导出模板 </el-button>
      <el-table
        max-height="450px"
        :data="importData"
        border
        style="margin-top: 8px"
        @selection-change="handleSelectionChangeImport"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="类型" prop="is_region" />
        <el-table-column label="名称" prop="houseName" />
        <el-table-column label="计划月份" prop="type" />
        <el-table-column label="应收欠费" prop="target_money" />
        <el-table-column label="1月份" prop="1" />
        <el-table-column label="2月份" prop="2" />
        <el-table-column label="3月份" prop="3" />
        <el-table-column label="4月份" prop="4" />
        <el-table-column label="5月份" prop="5" />
        <el-table-column label="6月份" prop="6" />
        <el-table-column label="7月份" prop="7" />
        <el-table-column label="8月份" prop="8" />
        <el-table-column label="9月份" prop="9" />
        <el-table-column label="10月份" prop="10" />
        <el-table-column label="11月份" prop="11" />
        <el-table-column label="12月份" prop="12" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import ErpTree from "@/components/Admin/Common/erp-tree";
import imgurl from "@/assets/js/imgurl.js";
export default {
  name: "FinanceTarget",
  components: {
    ErpTree,
  },
  data() {
    return {
      form: {
        houseName: "",
        year: "",
        pageSize: 10,
        page: 1,
        mode: "1",
        month:""
      },
      addForm: {
        id: "",
        date: "",
        target: "",
        target_money: "",
        is_region: "0",
        house_id: "",
        type: "1",
      },
      pid: 0,
      listData: [],
      rules: {
        house_id: [{ required: true, message: "请选择目标", trigger: "blur" }],
        date: [{ required: true, message: "请选择生效年月", trigger: "blur" }],
        type: [{ required: true, message: "请选择收缴类型", trigger: "blur" }],
        target: [
          { required: true, message: "请选择填写目标收缴率", trigger: "blur" },
        ],
        target_money: [
          {
            required: true,
            message: "请选择填写目标收缴金额",
            trigger: "blur",
          },
        ],
      },
      options: [
        { value: "0", label: "项目" },
        { value: "1", label: "区域" },
      ],
      months: [1,2,3,4,5,6,7,8,9,10,11,12],
      typeOptions: [
        { value: "1", label: "当期" },
        { value: "2", label: "纯上一年" },
        { value: "3", label: "一年以上两年以内" },
        { value: "4", label: "两年以上" },
        { value: "5", label: "一年以上合计" },
      ],
      modal: false,
      targetList: [],
      loading: false,
      totalCount: 0,
      importVisible: false,
      url: "",
      multipleSelection: [],
      fileList: [],
      importData: [],
    };
  },
  created() {
    this.form.year = String(new Date().getFullYear());
  },
  mounted() {
    this.search();
    this.remoteMethod("");
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    var oa_user_id = window.localStorage.getItem("oa_user_id");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/FinanceTarget/importExcel?" +
      "login_name=" +
      login +
      "&token=" +
      token +
      "&oa_user_id=" +
      oa_user_id;
  },
  watch: {
    "addForm.type"(n, o) {
      if (n != o) {
        this.remoteMethod();
      }
    },
    "form.page"(n) {
      this.search();
    },
  },
  methods: {
    nodeClick(data) {
      if (data.type == "project") {
        this.pid = data.id;
      }
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.form.houseName = tree_str;
    },
    addDialog() {
      this.addForm = {
        id: "",
        date: "",
        target: "",
        target_money: "",
        is_region: "0",
        house_id: "",
        type: "1",
      };
      this.modal = true;
    },
    search() {
      this.$myhttp
        .post("admin/FinanceTarget/index", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount;
            // this.form.page = backdata.data.page;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    edit(id) {
      this.view(id);
      this.modal = true;
    },
    view(id) {
      this.$myhttp
        .post(
          "admin/FinanceTarget/viewTarget",
          { id },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.addForm = backdata.data.data;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    del(id) {
      this.$myhttp
        .post(
          "admin/FinanceTarget/deleteTarget",
          { id },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.search();
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$myhttp
            .post("admin/FinanceTarget/saveTarget", this.addForm, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg);
                this.search();
                this.handleClose();
              } else {
                this.$message.error(backdata.data.msg);
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        } else {
        }
      });
    },
    openDialog() {
      this.importVisible = true;
    },
    handleCloseImport() {
      this.importData = [];
      this.importVisible = false;
    },
    handleClose() {
      this.addForm = {
        id: "",
        year: "",
        target: "",
        target_money: "",
        type: "1",
        house_id: "",
      };
      this.modal = false;
    },
    remoteMethod(keyword) {
      this.loading = true;
      this.$myhttp
        .post(
          "admin/FinanceTarget/getTargetList",
          {
            keyword,
            type: this.addForm.type,
            house_id: this.addForm.house_id,
          },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          this.loading = false;
          this.targetList = backdata.data.data;
        });
      this.loading = false;
    },
    //删除
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.importData = [];
        })
        .catch(() => {});
    },
    handleAvatarSuccess(response, file, fileList) {
      if (response.code == 200) {
        this.importData = response.data.length > 0 ? response.data : [];
      }
    },
    //超过一个文件
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //限制大小
    beforeAvatarUpload(file) {
      const isLt7M = file.size / 1024 / 1024 < 8;
      if (!isLt7M) {
        this.$message.error("上传文件大小不能超过 8MB!");
      }
      return isLt7M;
    },
    handleSelectionChangeImport(val) {
      this.multipleSelection = val;
    },
    // 删除节点
    delNode() {
      if (this.multipleSelection.length == 0) {
        return;
      }
      let data = [];
      if (this.importData.length == this.multipleSelection.length) {
        this.importData = [];
        this.multipleSelection = [];
      } else {
        this.importData.map((req) => {
          let bool = true;
          this.multipleSelection.map((reqs) => {
            if (
              req.houseName == reqs.houseName &&
              req.is_region == reqs.is_region &&
              req.type == reqs.type
            ) {
              bool = false;
            }
          });
          if (bool) {
            data.push(req);
          }
        });
      }
      this.importData = data;
    },
    importExcelData() {
      this.loading = true;
      this.$myhttp
        .post(
          "admin/FinanceTarget/importExcelData",
          { data: this.importData },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
            this.loading = false;
            this.handleCloseImport();
          } else {
            this.loading = false;
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    downloadExcel() {
      let url = imgurl + "/excel/目标导入模板.xlsx";
      window.open("/office.html#/office?url=" + url, "_blank");
    },
    //导出
    excelPost() {
      ERP.showLoading();
      this.$myhttp
        .post("admin/FinanceTarget/exportExcel", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            ERP.hideLoading();
            let url = imgurl + backdata.data.data;
            window.open("/office.html#/office?url=" + url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
            ERP.hideLoading();
          }
        })
        .catch((err) => {
          ERP.hideLoading();
          this.$message.error(err);
        });
    },
  },
};
</script>

<style>
.left {
  border-right: 1px solid #eee;
  width: 250px;
  float: left;
}
.right {
  float: right;
  width: calc(100% - 253px);
}
.box {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/FinanceTarget.vue